import { useShipContext } from "../../../../context/shipContext";
import { RatesTable } from "../../../Tables/RatesTable";
import {
  COMPLETE_RATE_SELECTION_STEP,
  PREVIOUS_STEP,
} from "../../../../reducers/types";
import { SecondaryButton } from "../../../Buttons/SecondaryButton";
import { InsuranceNotice } from "../../../Alerts/InsuranceNotice";

export function SelectCourierForm() {
  const { state: shipState, dispatch } = useShipContext();

  const handleRateSelect = (rate) => {
    dispatch({
      type: COMPLETE_RATE_SELECTION_STEP,
      payload: rate,
    });
  };

  const goBack = () => {
    dispatch({
      type: PREVIOUS_STEP,
    });
  };
  return (
    <div data-testid="ship-select-courier-step">
      {shipState.rates.length > 0 ? (
        <>
          <InsuranceNotice />
          <RatesTable
            rates={shipState?.rates}
            onSelect={handleRateSelect}
            selectedRate={shipState?.selectedRate}
          />
        </>
      ) : (
        <div>No rates found</div>
      )}
      <div className="mt-5 w-full flex justify-end">
        <SecondaryButton text="Back" onClick={goBack} />
      </div>
    </div>
  );
}
